import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { Machine } from '../../api/models';
import { SelectSearchOption } from '../models/select-search-option';

@Component({
  selector: 'lib-machine-picker',
  templateUrl: './machine-picker.component.html',
  styleUrls: ['./machine-picker.component.scss'],
  standalone: false,
})
export class MachinePickerComponent implements OnInit {
  constructor() {}

  private translate = inject(TranslateService);

  @Input()
  preselectedItem: string | null;
  @Input()
  items: Observable<Machine[]>;
  @Input()
  required = false;
  @Input()
  showAllEntry: boolean;
  @Output()
  selectedItemChanged: EventEmitter<string | null> = new EventEmitter<
    string | null
  >();

  machineOptions: Observable<SelectSearchOption<string | null>[]>;

  ngOnInit() {
    this.machineOptions = (this.items ?? of([])).pipe(
      map((machines) => {
        const options = (machines ?? []).map((machine) => ({
          value: machine.id,
          label: `${machine.inventoryNumber} ${machine.category} ${machine.manufacturer} ${machine.type}`,
        }));
        if (this.showAllEntry) {
          options.unshift({
            value: null,
            label: this.translate.instant('machinery.all'),
          });
        }
        return options;
      })
    );
  }

  onSelectionChanged(
    selection: SelectSearchOption<string | null> | null
  ): void {
    this.selectedItemChanged.emit(selection?.value ?? null);
  }

  getPreselectedItem(): any {
    if (this.preselectedItem != null) return of(this.preselectedItem);
    return this.items.pipe(
      map((x) => {
        return x?.length == 1 ? x[0].id : null;
      })
    );
  }
}
